import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock, TrendingUp, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export default function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error('Por favor ingresa la contraseña');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, { password });
      const { token, expires_at } = response.data;
      
      // Save token to localStorage
      localStorage.setItem('auth_token', token);
      localStorage.setItem('auth_expires', expires_at);
      
      toast.success('¡Bienvenido!');
      onLogin(token);
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Contraseña incorrecta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#0B0D0F',
      padding: '1rem'
    }}>
      <div className="card" style={{ width: '400px', maxWidth: '100%' }}>
        <div style={{
          padding: '2rem 1.5rem',
          textAlign: 'center',
          background: 'radial-gradient(200px 150px at 50% 0%, rgba(20, 184, 166, 0.15), transparent)',
          borderBottom: '1px solid #1E2329'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            margin: '0 auto 1rem',
            background: 'linear-gradient(135deg, #14B8A6, #0EA5A0)',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <TrendingUp size={32} color="#0B0D0F" />
          </div>
          <h1 style={{ 
            fontSize: '1.5rem', 
            fontWeight: 700, 
            color: '#E6E8EC',
            margin: 0
          }}>
            CryptoAlgo
          </h1>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#9AA3AF',
            margin: '0.5rem 0 0'
          }}>
            Trading Bot Personal
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '1.5rem' }}>
          <div className="form-group">
            <label className="form-label">
              <Lock size={14} style={{ display: 'inline', marginRight: '0.5rem' }} />
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              placeholder="Ingresa tu contraseña"
              autoFocus
              data-testid="login-password-input"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={loading}
            style={{ width: '100%', marginTop: '0.5rem' }}
            data-testid="login-submit-button"
          >
            {loading ? (
              <><Loader2 size={20} className="loading-spinner" /> Verificando...</>
            ) : (
              <>Entrar</>
            )}
          </button>
        </form>

        <div style={{
          padding: '1rem 1.5rem',
          borderTop: '1px solid #1E2329',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '0.75rem', color: '#6B7280', margin: 0 }}>
            Acceso restringido. Solo usuarios autorizados.
          </p>
        </div>
      </div>
    </div>
  );
}
